import cx from "classnames";
import React from "react";
import { useSelector } from "react-redux";

import { Icon, IconSize } from "@gaming/xds-react-js";
import { Settings } from "@gaming/xds-react-js-icons";

import { privacyPolicyURL } from "../../constants";
import { useStrings } from "../../localization/localizationHelpers";
import { getOnboardingSignedIn } from "../../redux/selectors/authSelectors";
import * as styles from "./PrivacyPolicyLink.module.css";

interface PrivacyPolicyLinkProps {
  showInPane?: boolean;
}

export const PrivacyPolicyLink = ({ showInPane }: PrivacyPolicyLinkProps) => {
  const [privacyPolicy, viewPrivacyPolicy] = useStrings("privacyPolicy", "viewPrivacyPolicy");
  const isSignedIn = useSelector(getOnboardingSignedIn);

  const colorStyle = styles.colorStyle;

  if (!isSignedIn) {
    return null;
  }

  return (
    <div className={cx(styles.linkContainer, colorStyle)}>
      {showInPane && <Icon icon={Settings} aria-hidden={true} iconSize={IconSize.Custom} />}
      <a
        className={showInPane ? cx(styles.link, colorStyle) : cx(styles.linkBig, colorStyle)}
        href={privacyPolicyURL}
        target="_blank"
        rel="noopener noreferrer"
      >
        {showInPane ? privacyPolicy : viewPrivacyPolicy}
      </a>
    </div>
  );
};
